<template>
    <div class="product-review-modal">
        <h2>{{ messages.modalTitle }}</h2>

        <form action="" class="product-review-form" @submit.prevent="addReview">
            <div class="product-review-form__block">
              <div v-html="description"></div>
              <div class="g-recaptcha" id="recaptcha-1" :data-sitekey="recaptchaKey"></div>
            </div>
            <div class="product-review-form__block">
                <DefInput
                        :placeholder="messages.name"
                        name="name"
                        :value="user.firstName"
                        :required="true"
                />
                <DefEmail
                        placeholder="E-mail"
                        name="email"
                        :value="user.email"
                        :required="true"
                />
                <div class="rating-title"><span>{{ messages.rating }}</span></div>
                <DefRating v-model="rating"/>
                <div class="def-bt white add-files desktop" onclick="document.getElementById('files').click();">Завантажити фото</div>
                <input type="file" multiple name="photo[]" class="hide" id="files">
            </div>
            <div class="product-review-form__block text-area">
                <div class="text-area__title"><span>{{ messages.reviewText }}</span></div>
                <textarea name="comment" required class="text-area__context"></textarea>
                <div class="def-bt white add-files mobile" onclick="document.getElementById('files').click();">Завантажити фото</div>
                <DefButtonPrimary type="submit">
                    {{ messages.leaveReview }}
                </DefButtonPrimary>
                <div v-if="errors.length > 0" class="error" v-for="error in errors">
                    <span>{{ error }}</span>
                </div>
            </div>

        </form>
    </div>
</template>

<script>
    import DefInput from "../../../Def/DefInput/DefInput.vue";
    import DefEmail from "../../../Def/DefEmail/DefEmail.vue";
    import DefRating from "../../../Def/DefRating/DefRating.vue";
    import DefButtonPrimary from "../../../Def/DefButtonPrimary/DefButtonPrimary.vue";
    import ProductReviewSuccessModal from "./ProductReviewSuccessModal.vue";
    import DefModal from "../../../Def/DefModal/DefModal.vue";

    export default {
        name: "ProductReviewModal",
        components: {DefModal, ProductReviewSuccessModal, DefButtonPrimary, DefRating, DefEmail, DefInput},
        selector: ".product-review-modal",
        props: ['messages', 'description', 'user', 'product', 'depth_level', 'parent_comment', 'recaptchaKey'],

        data() {
            return {
                rating: 5,
                reCaptchaToken: '',
                errors: [],
            }
        },
        methods: {
          closeModal: function () {
            this.$emit('close');
          },
          async addReview({target}) {
            try {
              // await this.recaptcha();
              let captcha = grecaptcha.getResponse(1);

              if (captcha.length) {
                const formData = new FormData(target);
                formData.append('id', this.product.id);
                formData.append('product_name', this.product?.name);
                formData.append('rating', this.rating);
                formData.append('depth_level', this.depth_level);
                formData.append('parent_comment', this.parent_comment);
                formData.append('g-recaptcha-response', captcha);
                const response = await this.$store.dispatch('product/addComment', formData);
                if (response) {
                  if (response.errors) {
                    this.errors = response.errors;
                  } else {
                    this.closeModal();
                    this.openSuccessModal();
                  }
                }
              }
            } catch (err) {
              console.error(err);
            }
          },
          /**
           * получения кода рекаптчи для отправки на сервер
           * google reCaptcha v3
           * https://www.google.com/recaptcha/admin/site/606327850/settings
           */
          async recaptcha() {
            // (optional) Wait until recaptcha has been loaded.
            await this.$recaptchaLoaded();

            // Execute reCAPTCHA with action "submit".
            const token = await this.$recaptcha('submit');

            this.reCaptchaToken = token;

            // Do stuff with the received token.
          },
          openSuccessModal() {
            this.$emit('openSuccessModal', this.messages);
          }
        },
    }
</script>

<style lang="scss" scoped>
    .product-review-modal {
        h2 {
            padding: 30px 0 0 50px;
            margin-bottom: 20px;
        }

        &__close {
            cursor: pointer;
            position: absolute;
            top: 8px;
            right: 8px;
            z-index: 1;

            svg {
                fill: #85898B;
                width: 20px;
                height: 20px;
            }
        }
    }

    .product-review-form {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        gap: 15px;
        padding: 0 50px 50px 50px;
        font-size: rem(12);

        &__block {
            width: 100%;
            .text-area {
                &__title {
                    margin-bottom: 5px
                }
                &__context {
                    font-size: rem(16);
                    width: 100%;
                    border: 1px solid #c5c4be;
                    border-radius: 0;
                    height: 110px;
                    resize: none;
                    padding: 12px;
                    margin-bottom: 15px;

                    @include point-md {
                        font-size: rem(14);
                    }
                }
            }
            .error {
                margin-top: 10px;
                color: red;
            }
            .add-files {
              margin-top: 18px;
            }
            .add-files.desktop {
              display: none;
            }
            .add-files.mobile {
              display: block;
              margin-bottom: 18px;
            }
            @include point-md {
              .add-files.desktop {
                display: block;
              }
              .add-files.mobile {
                display: none;
              }
            }
        }

        @include point-lg {
            flex-direction: row;
            gap: 80px;
        }

        :deep(.def-input__input),
        :deep(.def-email__input) {
            background-color: transparent;
            border-radius: 0;
            border: none;
            border-bottom: 1px solid var(--background-black);
            padding: 6px 20px 0 0;
        }

        :deep(.def-input__invalid),
        :deep(.def-email__invalid) {
            border-bottom-color: var(--background-red);
        }

        :deep(.def-rating) {
            position: relative;
            left: -2px;
        }

        :deep(.def-button-primary) {
            width: 100%;
            border: 0;
            cursor: pointer;
        }
    }
</style>